import { render } from "./TableViewIndividual.vue?vue&type=template&id=ad1ed010&ts=true"
import script from "./TableViewIndividual.vue?vue&type=script&lang=ts"
export * from "./TableViewIndividual.vue?vue&type=script&lang=ts"

import "./TableViewIndividual.vue?vue&type=style&index=0&id=ad1ed010&lang=scss"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__